<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
            <v-card-title class="teal darken-2">
                <span class="title" style="color: #fff;">{{ title }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>{{ messageText }}</v-card-text>

            <v-divider></v-divider>

            <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                <v-spacer></v-spacer>
                <v-btn color="success" @click="dialog = false">ok</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "MessageBox",

        data () {
            return {
                dialog:      false,
                title:       "",
                messageText: ""
            }
        }
    }
</script>
